import { styled } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { CommonSection } from "./CommonSection";
import { RectangularSkeleton2 } from "../../pages/home/Skeleton";
import {
  NextArrow,
  PrevArrow,
  SectionHeader,
  SectionTitle,
  Tag,
} from "../home/PopularCakes";

function SuggestedProducts({ data, isLoading }) {
  if (data?.products?.length == 0) return null;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <Section>
      <CommonSection sx={{ margin: "0 2rem" }}>
        {isLoading ? (
          <RectangularSkeleton2 />
        ) : (
          <>
            <SectionHeader>
              <SectionTitle>Suggested Products</SectionTitle>
            </SectionHeader>
            <SliderWrapper>
              <Slider {...settings}>
                {data?.products?.map((item, index) => (
                  <OfferCard key={index}>
                    {item?.variation?.[0]?.discountPercent && (
                      <DiscountBadge>
                        {item?.variation?.[0]?.discountPercent}% Off
                      </DiscountBadge>
                    )}

                    <OfferImage
                      src={item.app_image.app_product_image}
                      alt={item.name}
                    />
                    <OfferContent>
                      <OfferName>{item.product_name}</OfferName>
                      <Tag>{item?.flavour?.[0]?.itemName}</Tag>
                      <PriceContainer>
                        <Price>
                          ₹
                          {item?.variation?.[0]?.eggOriginalPrice > 0
                            ? item?.variation?.[0]?.eggOriginalPrice
                            : item?.variation?.[0]?.eggLessOriginalPrice}
                        </Price>
                        <ViewButton>
                          <ArrowForwardIcon />
                        </ViewButton>
                      </PriceContainer>
                    </OfferContent>
                  </OfferCard>
                ))}
              </Slider>
            </SliderWrapper>
          </>
        )}
      </CommonSection>
    </Section>
  );
}

const Section = styled("section")(({ theme }) => ({
  padding: "20px",
  background: "var(--neutral-100)",
  // background:
  //   "linear-gradient(180deg, rgba(242, 45, 52, 0.15) 37.38%, rgba(252, 237, 238, 0.43) 100%)",
}));

const SliderWrapper = styled("div")(({ theme }) => ({
  ".slick-slide": {
    padding: "0 16px",
  },
  ".slick-list": {
    margin: "0 -20px",
  },
}));

const OfferCard = styled("div")(({ theme }) => ({
  position: "relative",
  background: "white",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
  height: "400px",
  width: "295px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
}));

const DiscountBadge = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "0",
  left: "0",
  color: "white",
  fontSize: "14px",
  fontWeight: 500,
  zIndex: 1,
  background: "#08b176",
  borderRadius: "6px 6px 6px 0",
  padding: "4px 12px",
  width: "100px",
  height: "32px",
  fontWeight: "600",
  fontSize: "18px",
  lineHeight: "120%",
  color: "var(--neutral-white)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const OfferImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "240px",
  objectFit: "contain",
}));

const OfferContent = styled("div")(({ theme }) => ({
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
  height: "100%",
}));

const OfferName = styled("h3")(({ theme }) => ({
  fontWeight: "600",
  fontSize: "20px",
  lineHeight: "150%",
  color: "var(--neutral-800)",
  textAlign: "left",
  margin: "0 0 8px 0",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

const PriceContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "16px",
}));

const Price = styled("span")(({ theme }) => ({
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "133%",
  color: "var(--neutral-black)",
}));

const ViewButton = styled("button")(({ theme }) => ({
  background: "var(--primary-red-base)",
  color: "white",
  border: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  "&:hover": {
    background: "#FF5252",
  },
  borderRadius: "8px",
  width: "48px",
  height: "48px",
}));

export default SuggestedProducts;
